import {
  SET_CONTEXT_QUESTION_ANSWER,
  SET_MAIN_QUESTION_ANSWER,
  RESET_SUBMISSION_STATE,
  RECALL_SUBMISSION_STATE,
  DELETE_SECTION_SUBMISSIONS,
  SET_DISCARD_SUBMISSION_SECTION,
  CREATE_EMPTY_SUBMISSION_SECTIONS,
  SubmissionActionType,
  SubmissionSectionContext,
  MainSubmissionAnswerPayload,
  SubmissionPayload,
} from '../types/submissionTypes';

export const setContextQuestionAnswer = (
  sectionIndex: number,
  questionUuid: string,
  payload: SubmissionSectionContext['uuid'],
): SubmissionActionType => ({
  type: SET_CONTEXT_QUESTION_ANSWER,
  sectionIndex,
  questionUuid,
  payload,
});

export const setSamplePayload = (
  sectionIndex: number,
  questionUuid: string,
  sampleIndex: number,
  answerPayload: MainSubmissionAnswerPayload,
): SubmissionActionType => ({
  type: SET_MAIN_QUESTION_ANSWER,
  sectionIndex,
  questionUuid,
  sampleIndex,
  answerPayload,
});

export const resetSubmissionState = (): SubmissionActionType => ({
  type: RESET_SUBMISSION_STATE,
});

export const setDiscardSubmissionSection = (
  sectionId: number, discard: boolean,
): SubmissionActionType => ({
  type: SET_DISCARD_SUBMISSION_SECTION,
  payload: {
    sectionId,
    discard,
  },
});

export const recallSubmissionState = (
  submissionPayload: SubmissionPayload,
): SubmissionActionType => ({
  type: RECALL_SUBMISSION_STATE,
  payload: submissionPayload,
});

export const deleteSectionSubmissions = (sectionId: number): SubmissionActionType => ({
  type: DELETE_SECTION_SUBMISSIONS,
  payload: {
    sectionId,
  },
});

export const createEmptySubmissionSections = (numSections: number): SubmissionActionType => ({
  type: CREATE_EMPTY_SUBMISSION_SECTIONS,
  payload: {
    numSections,
  },
});
